


































































import BaseComponent from "@/components/base/BaseComponent";
import {MemberType} from "@/components/dashboard/process-management/model/ProcessManagmentTypes";
import {v4 as uuidv4} from "uuid";
import {Component, Prop} from 'vue-property-decorator';

@Component({})
export default class LegallyWithdrawingFunds extends BaseComponent {

  @Prop(Number) memberType!: any

  private uniqueId = uuidv4();
  private employeeBenefitWithdrawal: number | null = 0; // Default to 0
  private endEmploymentDate: any = ''

  private onRadioChange(value: number): void {
    console.log("value", value)
    this.employeeBenefitWithdrawal = value;

    this.$emit("handleRadioSelectionChange", value);
  }

  get isSelfEmployed() {
    return this.memberType == MemberType.SELF_EMPLOYED;
  }

  get isEmployee() {
    return this.memberType == MemberType.EMPLOYEE
  }

  handleEndEmploymentDateChanged(input: any) {


    this.$emit("handleEndEmploymentDateChange", input);
  }

  clearIllegalWithdrawalRadioChoice() {
    this.employeeBenefitWithdrawal = null

    this.$emit("handleRadioSelectionChange", null);
  }
}
